/**
 * @generated SignedSource<<876a392fad769ad578b9c68d57790e55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupType = "FEATURE" | "PERMISSION" | "RELEASE" | "UNKNOWN" | "%future added value";
export type GroupsFilterQuery$variables = {
  groupType?: GroupType | null;
  groupUuids?: ReadonlyArray<string | null> | null;
};
export type GroupsFilterQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GroupsFilterSelectedGroups_query" | "GroupsFilter_query">;
};
export type GroupsFilterQuery = {
  response: GroupsFilterQuery$data;
  variables: GroupsFilterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupUuids"
},
v2 = {
  "kind": "Variable",
  "name": "groupType",
  "variableName": "groupType"
},
v3 = {
  "kind": "Variable",
  "name": "groupUuids",
  "variableName": "groupUuids"
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "GroupEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Group",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  },
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GroupsFilterQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GroupsFilter_query"
      },
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GroupsFilterSelectedGroups_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GroupsFilterQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "GroupConnection",
        "kind": "LinkedField",
        "name": "groups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "filters": [
          "searchTerm",
          "groupType"
        ],
        "handle": "connection",
        "key": "GroupsFilter_groups",
        "kind": "LinkedHandle",
        "name": "groups"
      },
      {
        "alias": "selectedGroups",
        "args": (v7/*: any*/),
        "concreteType": "GroupConnection",
        "kind": "LinkedField",
        "name": "groups",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "selectedGroups",
        "args": (v7/*: any*/),
        "filters": [
          "groupUuids"
        ],
        "handle": "connection",
        "key": "GroupsFilter_selectedGroups",
        "kind": "LinkedHandle",
        "name": "groups"
      }
    ]
  },
  "params": {
    "cacheID": "1fd4da80f3dbb86457db74f30c4a8a1e",
    "id": null,
    "metadata": {},
    "name": "GroupsFilterQuery",
    "operationKind": "query",
    "text": "query GroupsFilterQuery(\n  $groupUuids: [String]\n  $groupType: GroupType\n) {\n  ...GroupsFilter_query_Y3Wnp\n  ...GroupsFilterSelectedGroups_query_gf99O\n}\n\nfragment GroupsFilterSelectedGroups_query_gf99O on Query {\n  selectedGroups: groups(first: 5, groupUuids: $groupUuids) {\n    edges {\n      node {\n        id\n        uuid\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment GroupsFilter_query_Y3Wnp on Query {\n  groups(first: 10, groupType: $groupType) {\n    totalCount\n    edges {\n      node {\n        id\n        uuid\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f9c365bfc9f95d12e280fddbcb0f406";

export default node;
